import PropTypes from 'prop-types';
// material
import { ThemeProvider, createTheme, useTheme } from '@mui/material/styles';
// hooks
import useLocales from '../hooks/useLocales';

// ----------------------------------------------------------------------

ThemeLocalization.propTypes = {
  children: PropTypes.node
};

export default function ThemeLocalization({ children }) {
  const defaultTheme = useTheme();
  const { currentLang } = useLocales();

  // Ensure typography.fontSize and shape.borderRadius are numbers before creating theme
  const sanitizedTheme = { ...defaultTheme };
  
  if (sanitizedTheme.typography?.fontSize !== undefined) {
    if (Array.isArray(sanitizedTheme.typography.fontSize)) {
      sanitizedTheme.typography = { 
        ...sanitizedTheme.typography, 
        fontSize: sanitizedTheme.typography.fontSize[0] 
      };
    }
    if (typeof sanitizedTheme.typography.fontSize !== 'number') {
      sanitizedTheme.typography = { 
        ...sanitizedTheme.typography, 
        fontSize: 14 
      };
    }
  }

  if (sanitizedTheme.shape?.borderRadius !== undefined) {
    if (Array.isArray(sanitizedTheme.shape.borderRadius)) {
      sanitizedTheme.shape = { 
        ...sanitizedTheme.shape, 
        borderRadius: sanitizedTheme.shape.borderRadius[0] 
      };
    }
    if (typeof sanitizedTheme.shape.borderRadius !== 'number') {
      sanitizedTheme.shape = { 
        ...sanitizedTheme.shape, 
        borderRadius: 8 
      };
    }
  }

  const theme = createTheme(sanitizedTheme, currentLang.systemValue);

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}
